import _ from 'lodash'
import toastr from 'toastr'
import { funcModal } from 'components/modals'
import moment from 'moment'
import { Captcha, DataLayer, twoFactorPolicy, user, webauthn } from 'services'

const components = {
  funcModal
}

let computed = {
  user () {
    return user.getUser();
  },
} 

const methods = {
  finishLogin () {
    if (!isServer) {
      DataLayer.login(this.user);
    }

    if (user.preventAccess()) {
      this.$store.dispatch('user.logout').then(() => {
        window.location.href = "/login";
      });
      return;
    }

    if (twoFactorPolicy.requiresSetup(this.user)) {
      this.$router.replace({ name: 'profile.security' })
      return
    }

    if (this.$route.query.goto) {
      let {href} = this.$router.resolve(this.$route.query.goto);
      console.log('hreffffff---', href);

      window.location.href = href;
    } else {
      this.$router.push({ name: 'home'});
    }
  },

  handleAuthResult () {
    this.loading = false;
    let errors = this.$store.state.user.errors;
    if (errors) {
      if (errors.errors) {
        this.errors = _.cloneDeep(errors.errors);
      }
      toastr.error(errors.message);
      return;
    }
    if (this.$store.state.user.twoFactorRequired) {
      this.awaitingTwoFactor = true;
      this.twoFactorCode = '';
      return;
    }
    this.finishLogin();
  },

  async submit (email, password) {
    // this.cancelConditionalPasskey();
    this.errors = {};
    this.loading = true;
    this.email = email;
    let token = await Captcha.execute('login');
    this.$store.dispatch('user.login', {email, password, token, fingerprint: this.fingerprint}).then(() => {
      this.handleAuthResult();
    });
  },

  // cancelConditionalPasskey () {
  //   this.conditionalPasskeyCancelled = true;
  //   if (this.conditionalPasskeyTimer) {
  //     clearTimeout(this.conditionalPasskeyTimer);
  //     this.conditionalPasskeyTimer = null;
  //   }
  //   if (this.conditionalPasskeyController) {
  //     this.conditionalPasskeyController.abort();
  //     this.conditionalPasskeyController = null;
  //   }
  // },

  signInWithPasskey () {
    // this.cancelConditionalPasskey();
    this.errors = {};
    this.passkeyLoading = true;
    const email = this.email ? this.email.trim() : '';
    this.$store.dispatch('user.loginPasskey', {
      email: email || undefined,
      fingerprint: this.fingerprint,
      mediation: 'optional'
    }).then(() => {
      this.passkeyLoading = false;
      this.finishLogin();
    }).catch((error) => {
      this.passkeyLoading = false;
      if (error && error.name === 'AbortError') return;
      const errors = this.$store.state.user.errors;
      if (errors && errors.errors) this.errors = _.cloneDeep(errors.errors);
      toastr.error(webauthn.errorMessage(error, 'get'));
    });
  },

  // startConditionalPasskey () {
  //   if (!this.passkeysSupported || typeof AbortController === 'undefined') return;
  //   webauthn.isConditionalMediationAvailable().then((available) => {
  //     if (!available || this.conditionalPasskeyCancelled) return;
  //     this.beginConditionalPasskey();
  //   });
  // },

  // beginConditionalPasskey () {
  //   if (this.conditionalPasskeyCancelled) return;
  //   const controller = new AbortController();
  //   this.conditionalPasskeyController = controller;
  //   this.conditionalPasskeyTimer = setTimeout(() => {
  //     if (this.conditionalPasskeyCancelled) return;
  //     controller.abort();
  //     if (this.conditionalPasskeyController === controller) {
  //       this.conditionalPasskeyController = null;
  //     }
  //     this.beginConditionalPasskey();
  //   }, 4 * 60 * 1000);
  //
  //   this.$store.dispatch('user.loginPasskey', {
  //     fingerprint: this.fingerprint,
  //     mediation: 'conditional',
  //     signal: controller.signal
  //   }).then(() => {
  //     this.cancelConditionalPasskey();
  //     this.finishLogin();
  //   }).catch((error) => {
  //     if (this.conditionalPasskeyController === controller) {
  //       this.conditionalPasskeyController = null;
  //     }
  //     if (error && (error.name === 'AbortError' || error.name === 'NotAllowedError')) return;
  //     this.cancelConditionalPasskey();
  //     const errors = this.$store.state.user.errors;
  //     if (errors && errors.errors) this.errors = _.cloneDeep(errors.errors);
  //     toastr.error(webauthn.errorMessage(error, 'get'));
  //   });
  // },

  submitTwoFactor () {
    this.errors = {};
    this.loading = true;
    this.$store.dispatch('user.verify2fa', {
      code: this.twoFactorCode,
      email: this.email,
      fingerprint: this.fingerprint
    }).then(() => {
      this.handleAuthResult();
    });
  },

  backToLogin () {
    this.awaitingTwoFactor = false;
    this.twoFactorCode = '';
    this.errors = {};
    this.$store.dispatch('user.clearTwoFactorChallenge');
  },

  setFingerprint () {
    let fingerprint = localStorage.getItem('fingerprint');
    if (!fingerprint) {
      fingerprint = Math.floor(Math.random() * 1000000).toString();
      localStorage.setItem('fingerprint', fingerprint);
    }
    return fingerprint;
  },

  openSendEmail () {
    this.$refs.forgotPass.open();
  },

  closeSendEmail () {
    this.forgotPass.email = null;
    this.errors = {};
  },

  submitSendEmail (modal) {
    this.errors = {};
    this.processing = true;
    this.$store.dispatch('user.forgotPassword', this.forgotPass.email).then(() => {
      this.processing = false;
      let errors;
      if (errors = this.$store.state.user.errors) {
        this.errors = errors.errors;
      } else {
        if (!isServer) {
          DataLayer.resetPassword(this.forgotPass.email, this.user);
        }
        this.forgotPass.email = null;
        toastr.success("Please check your email");
        modal.close();
      }
    });
  }
}

export default {
  name: "login-layout",
  methods,
  components,
  computed,
  data () {
    return {
      errors: {},
      forgotPass: {
        email: null
      },
      loading: false,
      processing: false,
      captchaLoaded: false,
      year: moment().format('YYYY'),
      fingerprint: null,
      awaitingTwoFactor: false,
      twoFactorCode: '',
      email: '',
      passkeysSupported: false,
      passkeyLoading: false
      // conditionalPasskeyController: null,
      // conditionalPasskeyTimer: null,
      // conditionalPasskeyCancelled: false
    }
  },
  mounted () {
    Captcha.init();
    this.fingerprint = this.setFingerprint();
    this.passkeysSupported = webauthn.isSupported();
    // this.startConditionalPasskey();

    window.addEventListener('google_recaptcha_loaded', () => {
      Captcha.ready(() => {
        this.captchaLoaded = true;
      })
  });
  },
  created () {
    if (!isServer && user.hasFrontAccess()) {
      this.$router.replace({ name: 'home' });
    }
  }
  // beforeDestroy () {
  //   this.cancelConditionalPasskey();
  // }
}
